module.exports = __webpack_public_path__ + "img/pos.28e0a4ef.png";